import React from "react";
import {cx} from "../../../lib/ClassSet";
import "./UsTaxItem.css";

function renderBool(val) {
  if (val) return "Yes";
  return "No";
}

const UsTaxItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "sales-us-tax-settings-list-item": true,
    "u-selected": props.selected
  })

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id">{data.get("stateCode")}</td>
      <td className="field f-name">{data.get("name")}</td>
      <td className="field f-deduct-shipping-cost">{renderBool(data.get("deductShippingCost"))}</td>
    </tr>
  )
}

export default UsTaxItem;